import { type Locale } from "@/domain";

export const PR_ANCHOR_IDS = {
	reviewDisplay: "pr-reviewdisplay",
	questionDisplay: "pr-questiondisplay"
} as const;

interface PowerReviewsRenderConfig {
	api_key: string;
	locale: string;
	merchant_group_id: string;
	merchant_id: string;
	page_id: string;
	review_wrapper_url?: string;
	components: {
		ReviewDisplay?: string;
		ReviewSnippet?: string;
		QuestionDisplay?: string;
		Write?: string;
	};
}

interface PowerReviewsSdk {
	display: {
		render: (config: PowerReviewsRenderConfig) => void;
	};
}

declare global {
	var POWERREVIEWS: PowerReviewsSdk | undefined;
}

export interface PowerReviewRenderInput {
	sku: string;
	locale: Locale;
	apiKey: string;
	merchantGroupId: string;
	merchantId: string;
}

function toPowerReviewLocale(locale: Locale): "en_US" | "en_CA" {
	return locale === "en-CA" ? "en_CA" : "en_US";
}

export function renderPowerReview(input: PowerReviewRenderInput): void {
	if (
		typeof window === "undefined" ||
		typeof window.POWERREVIEWS === "undefined"
	) {
		return;
	}

	window.POWERREVIEWS.display.render({
		api_key: input.apiKey,
		locale: toPowerReviewLocale(input.locale),
		merchant_group_id: input.merchantGroupId,
		merchant_id: input.merchantId,
		page_id: input.sku,
		components: {
			ReviewDisplay: PR_ANCHOR_IDS.reviewDisplay,
			QuestionDisplay: PR_ANCHOR_IDS.questionDisplay
		}
	});
}

const PR_DETACHED_SELECTORS = [
	".pr-media-modal",
	".pr-content-collection-form",
	".pr-modal-flagging-form",
	".p-w-r_future",
	"body > .p-w-r"
] as const;

export function teardownPowerReview(): void {
	if (typeof document === "undefined") {
		return;
	}

	for (const id of Object.values(PR_ANCHOR_IDS)) {
		const el = document.getElementById(id);
		if (el) {
			el.innerHTML = "";
		}
	}

	for (const selector of PR_DETACHED_SELECTORS) {
		document.querySelectorAll(selector).forEach((node) => node.remove());
	}
}
